<template>
  <div class="dashboardWrapper">
    <side-bar></side-bar>
    <router-view></router-view>
  </div>
</template>

<script>
import sidebar from '@/components/sidebar/views/sidebar.vue'

export default {
  components: {
    'side-bar': sidebar
  },
  created: function () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dashboardWrapper{
  display : -webkit-flex;
  display : flex;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(245,246,250);
}
</style>



// WEBPACK FOOTER //
// src/components/board/views/board.vue